<template>
  <div id="app">
    <div id="hero" v-bind:class="{ hero: !user.loggedIn }">
      <nav
        v-if="!isAuthPage"
        id="nav"
        class="navbar"
        role="navigation"
        aria-label="main navigation"
      >
        <div class="navbar-brand">
          <router-link :to="{ name: 'events' }"
            ><img class="navlogo" src="/img/gobo-logo-black.svg" alt=""
          /></router-link>
          <a
            role="button"
            class="navbar-burger"
            :class="{ 'is-active': burgerToggle }"
            aria-label="menu"
            aria-expanded="false"
            @click="burgerToggle = !burgerToggle"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div class="navbar-menu" :class="{ 'is-active': burgerToggle }">
          <div
            id="center"
            v-if="user && user.loggedIn"
            class="navbar-item is-hidden-mobile"
          >
            <router-link class="navbar-item" to="/events">
              My Events
            </router-link>
            <router-link class="navbar-item" to="/help">Help</router-link>
          </div>
          <div
            id="center"
            v-if="!user || !user.loggedIn"
            class="navbar-item is-hidden-mobile"
          >
            <a class="navbar-item" href="https://tix.gobo.show"
              >Upcoming Events</a
            >
            <router-link class="navbar-item" to="/help">Help</router-link>
          </div>
          <div class="navbar-end" @click="burgerToggle = !burgerToggle">
            <div class="navbar-item" v-if="!user || !user.loggedIn">
              <a class="navbar-item" @click="login = true">Sign In</a>
            </div>
            <div
              class="navbar-item shaded"
              v-if="user && user.loggedIn && !user.venueManager"
            >
              <a @click="createEvent" class="button is-dark is-flex-mobile"
                >Create Event</a
              >
            </div>
            <div
              class="navbar-item shaded"
              v-if="user && user.loggedIn && user.venueManager"
            >
              <a
                @click="$router.push({ name: 'chooseEventType' })"
                class="button is-dark is-flex-mobile"
                >Create Event</a
              >
            </div>
            <div
              class="navbar-item shaded"
              v-if="user && user.loggedIn && user.festivalManager"
            >
              <a @click="createFestival" class="button is-dark is-flex-mobile"
                >Create Festival</a
              >
            </div>
            <router-link class="navbar-item is-hidden-tablet" to="/events">
              My Events
            </router-link>
            <router-link class="navbar-item is-hidden-tablet" to="/help"
              >Help</router-link
            >
            <a class="navbar-item is-hidden-tablet" @click="logout = true"
              >Sign Out</a
            >
            <div
              class="navbar-item is-hidden-mobile"
              v-if="user && user.loggedIn"
            >
              <Avatar />
              <div class="navbar-item has-dropdown is-hoverable">
                <router-link class="navbar-link" to="/profile">{{
                  user.name
                }}</router-link>
                <div class="navbar-dropdown is-boxed">
                  <router-link class="navbar-item" to="/profile"
                    >Account Settings</router-link
                  >
                  <a class="navbar-item" @click="logout = true">
                    Sign Out
                  </a>
                </div>
              </div>
            </div>
            <div class="buttons" v-if="!user || !user.loggedIn">
              <a class="button is-dark" @click="signup = true">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </nav>

      <router-view
        @signmeup="signmeup"
        @addcomp="addcomp"
        @walkup="walkup"
        @sellTickets="sellTickets"
        @sellPasses="sellPasses"
        @sellSeriesPasses="sellSeriesPasses"
        @pass="pass"
        @addpass="newpass"
        @move="move"
        @moveshow="moveshow"
      />
      <div v-if="!user || !user.loggedIn"></div>
      <div
        class="modal"
        :class="{
          'is-active':
            createArtist ||
            createVenue ||
            signup ||
            login ||
            logout ||
            showConfirm ||
            addingcomp ||
            walkingup ||
            showOrderDetails ||
            applyingpass ||
            addingpass ||
            userInvite ||
            buyTickets ||
            buyPasses ||
            buySeriesPasses ||
            moving ||
            movingshow
        }"
      >
        <div class="modal-background"></div>
        <div
          class="modal-content"
          :class="{ buyTickets: buyTickets || buySeriesPasses || buyPasses }"
        >
          <div id="modalwrapper" class="box">
            <div
              id="modalheader"
              v-if="!buyTickets && !buyPasses && !buySeriesPasses"
            >
              <a
                id="modalclose"
                @click="canceled()"
                v-if="!invitationId && !referralCode"
                ><i class="fas fa-times"></i
              ></a>
            </div>
            <div class="modal-inner-wrapper" :class="{ checkout: walkingup }">
              <SignUp
                @canceled="canceled"
                @saved="createduser"
                @switch-mode="switchAuthMode"
                v-if="signup"
                :invitationId="invitationId"
                :invitationError="invitationError"
                :referralCode="referralCode"
              />
              <LogIn
                @canceled="canceled"
                @loggedin="loggedin"
                @switch-mode="switchAuthMode"
                v-if="login"
                :reauthMessage="reauthMessage"
              />
              <LogOut
                @canceled="canceled"
                @loggedout="loggedout"
                v-if="logout"
              />
              <CreateArtist
                @canceled="canceled"
                @profileCreated="profileCreated"
                v-if="createArtist"
              />
              <CreateVenue
                @canceled="canceled"
                @profileCreated="profileCreated"
                v-if="createVenue"
              />
              <Confirm
                :header="confirmation.header"
                :message="confirmation.message"
                :cta="confirmation.cta"
                v-if="showConfirm && confirmation"
                @canceled="canceled"
              />
              <AddComp
                v-if="addingcomp"
                @canceled="canceled"
                @compAdded="canceled"
              />
              <Walkup
                v-if="walkingup"
                @canceled="canceled"
                @walkupAdded="canceled"
              />
              <OrderDetails
                v-if="showOrderDetails"
                :order="selectedOrder"
                :eventId="selectedEventId"
                @close="canceled"
              />
              <ApplyPass
                v-if="applyingpass"
                @canceled="canceled"
                @passApplied="canceled"
              />
              <AddPass
                v-if="addingpass"
                @canceled="canceled"
                @passApplied="canceled"
              />
              <Move v-if="moving" @canceled="canceled" @moved="canceled" />
              <MoveShow
                v-if="movingshow"
                @canceled="canceled"
                @moved="canceled"
              />
              <BuyTickets
                v-if="buyTickets"
                @canceled="canceled"
                :isPreview="true"
              />
              <BuyPasses
                v-if="buyPasses"
                :visible="buyPasses"
                @canceled="canceled"
              />
              <BuySeriesPasses v-if="buySeriesPasses" @canceled="canceled" />
              <InviteUser v-if="userInvite" @canceled="canceled" />
            </div>
            <div id="modalfooter"></div>
          </div>
        </div>
      </div>
    </div>
    <footer v-if="!isAuthPage" class="footer">
      <nav
        id="footer-nav-top"
        class="navbar is-hidden-mobile"
        role="navigation"
        aria-label="secondary navigation"
      >
        <div class="navbar-brand">
          <img class="navlogo" src="/img/gobo-logo-white.svg" alt="Gobo" />
        </div>
        <div class="navbar-end">
          <div class="navbar-item" v-if="!user || !user.loggedIn">
            <a class="navbar-item" @click="login = true">Sign In</a>
          </div>
          <div class="buttons" v-if="!user || !user.loggedIn">
            <a class="button is-light" @click="signmeup('footer')">
              Get Started
            </a>
          </div>
        </div>
      </nav>
      <div class="social is-hidden-tablet">
        <a href="https://twitter.com/goboshow/"
          ><span class="icon is-large">
            <i class="fab fa-2x fa-twitter"></i> </span
        ></a>
        <a href="https://www.facebook.com/Goboshow/"
          ><span class="icon is-large">
            <i class="fab fa-2x fa-facebook-f"></i> </span
        ></a>
        <a href="https://www.instagram.com/goboshow/"
          ><span class="icon is-large">
            <i class="fab fa-2x fa-instagram"></i> </span
        ></a>
      </div>
      <nav class="level is-mobile is-hidden-tablet">
        <div class="level-left">
          <img class="navlogo" src="/img/gobo-logo-white.svg" alt="Gobo" />
        </div>
        <div class="level-right">
          <div id="copy">
            &copy;{{ new Date().getFullYear() }} Gobo Show, Inc
          </div>
        </div>
      </nav>
      <div class="content has-text-centered is-hidden-mobile">
        <div id="spacer"></div>
        <nav
          id="footer-nav"
          class="navbar"
          role="navigation"
          aria-label="secondary navigation"
        >
          <div class="navbar-brand">
            <div id="copy">
              &copy;{{ new Date().getFullYear() }} Gobo Show, Inc
            </div>
          </div>
          <div id="center" class="navbar-item is-hidden-mobile">
            <a class="navbar-item" href="https://www.gobo.show/about-us"
              >Our Story</a
            >
            <router-link class="navbar-item" to="/help">Help</router-link>
            <a class="navbar-item" href="https://www.gobo.show/privacy-notice"
              >Privacy Notice</a
            >
            <router-link v-if="false" class="navbar-item" to="/about"
              >Terms of Service</router-link
            >
            <div class="navbar-end">
              <div class="navbar-item">
                <a href="https://twitter.com/goboshow"
                  ><img
                    class="socialicon"
                    src="/img/icons/Twitter.svg"
                    alt="Follow us on Twitter"
                /></a>
              </div>
              <div class="navbar-item">
                <a href="https://www.facebook.com/Goboshow/">
                  <img
                    class="socialicon"
                    src="/img/icons/Facebook.svg"
                    alt="Follow us on Facebook"
                /></a>
              </div>
              <div class="navbar-item">
                <a href="https://www.instagram.com/Goboshow/">
                  <img
                    class="socialicon"
                    src="/img/icons/Instagram.svg"
                    alt="Follow us on Instagram"
                /></a>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </footer>
    <GobotWidget />
    <!-- Onboarding Modal -->
    <OnboardingModal
      v-if="showOnboarding"
      :userName="onboardingUserName"
      @completed="onOnboardingComplete"
    />
    <!-- The way out of a retired app. Shown to anyone not signed in to it. -->
    <DeprecationModal
      v-if="showDeprecation"
      @continue-here="dismissDeprecation"
    />
  </div>
</template>

<style lang="scss">
.socialicon {
  height: 20px;
}
#hero.hero {
  background-image: url("/img/hero.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  height: 700px;
}
#nav {
  background: none;
  padding: 1.5em 2em 0;
}
#center {
  flex: 1;
  justify-content: center;
  padding-left: 130px;
}
#copy {
  font-size: 0.75em;
  padding: 1rem 0.75rem;
}
#spacer {
  min-height: 16rem;
}
</style>

<script>
import store from "@/store";
import SignUp from "@/components/signup";
import LogIn from "@/components/login";
import LogOut from "@/components/logout";
import Avatar from "@/components/avatar";
import CreateArtist from "@/components/create-artist-profile";
import CreateVenue from "@/components/create-venue-profile";
import Confirm from "@/components/confirm";
import AddComp from "@/components/add-comp";
import Walkup from "@/components/walkup";
import OrderDetails from "@/components/order-details";
import ApplyPass from "@/components/apply-pass";
import AddPass from "@/components/add-pass";
import Move from "@/components/move";
import MoveShow from "@/components/move-show";
import BuyTickets from "@/components/buy-tickets";
import BuyPasses from "@/components/buy-passes";
import BuySeriesPasses from "@/components/buy-series-passes";
import InviteUser from "@/components/invite-user";
import GobotWidget from "@/components/GobotWidget";
import OnboardingModal from "@/components/onboarding-modal.vue";
import DeprecationModal from "@/components/deprecation-modal.vue";
import { mapGetters } from "vuex";
import firebase from "firebase/app";

export default {
  name: "gobo",
  data() {
    return {
      burgerToggle: false,
      signup: true,
      login: false,
      logout: false,
      createArtist: false,
      createVenue: false,
      addingcomp: false,
      walkingup: false,
      showOrderDetails: false,
      selectedOrder: null,
      selectedEventId: null,
      applyingpass: false,
      addingpass: false,
      moving: false,
      movingshow: false,
      buyTickets: false,
      buyPasses: false,
      buySeriesPasses: false,
      invitationId: null,
      invitationError: false,
      referralCode: null,
      reauthMessage: ""
    };
  },
  components: {
    SignUp,
    LogIn,
    LogOut,
    CreateArtist,
    CreateVenue,
    Avatar,
    Confirm,
    AddComp,
    Walkup,
    OrderDetails,
    ApplyPass,
    AddPass,
    Move,
    MoveShow,
    BuyTickets,
    BuyPasses,
    BuySeriesPasses,
    InviteUser,
    GobotWidget,
    OnboardingModal,
    DeprecationModal
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
      profiles: "profiles",
      showConfirm: "showConfirm",
      confirmation: "confirmation",
      userInvite: "userInvite",
      receivedInvite: "receivedInvite",
      showOnboarding: "showOnboarding",
      onboardingUserName: "onboardingUserName",
      isAuthenticated: "isAuthenticated",
      deprecationDismissed: "deprecationDismissed"
    }),
    showDeprecation() {
      // Anyone signed in here is an allowed account by definition: main.js
      // signs everybody else straight back out.
      return !this.isAuthenticated && !this.deprecationDismissed;
    },
    isAuthPage() {
      const authRoutes = ["home", "login", "signup", "invitation", "referral"];
      return authRoutes.includes(this.$route.name);
    }
  },
  async mounted() {
    await this.cleanupServiceWorkers();
    this.signup = !this.user;
    if (this.$route.params.invitationId) {
      this.invitationId = this.$route.params.invitationId;
      this.signup = true;
      console.log("yoyo");
      await store.dispatch("findInvite", this.invitationId);
      if (!this.receivedInvite) this.invitationError = true;
    }

    if (this.$route.params.referralCode) {
      console.log("Referral code", this.$route.params.referralCode);
      this.referralCode = this.$route.params.referralCode;
      this.signup = true;
    }
    console.log("params", this.$route.params);

    // listen for login
    // you will need to modify this if profiles get modified in the future.
    store.subscribe(mutation => {
      console.log("route name", this.$route.name);
      // Skip navigation if onboarding modal is showing (handled by AuthView)
      if (this.showOnboarding) {
        return;
      }
      // Skip this legacy navigation for auth pages - AuthView handles its own routing
      const authRoutes = ["home", "login", "signup", "invitation", "referral"];
      if (
        mutation.type === "SET_USER" &&
        authRoutes.includes(this.$route.name)
      ) {
        // Let AuthView handle navigation after login/signup
        return;
      }
      // Listen for reauth login request
      if (mutation.type === "SHOW_REAUTH_LOGIN") {
        this.reauthMessage = mutation.payload;
        this.login = true;
      }
    });
  },
  methods: {
    dismissDeprecation() {
      store.dispatch("dismissDeprecation");
      // The link promises the login page, so take them there rather than
      // leaving them on whatever the notice was covering.
      if (this.$route.name !== "login") {
        this.$router.push({ name: "login" }).catch(() => {});
      }
    },
    // FIX: Added method to handle toggling between Login and Signup modes
    switchAuthMode(mode) {
      if (mode === "login") {
        this.signup = false;
        this.login = true;
      } else if (mode === "signup") {
        this.login = false;
        this.signup = true;
      }
    },
    canceled() {
      store.dispatch("confirm", false);
      this.signup = this.login = this.logout = this.createArtist = this.createVenue = this.addingcomp = this.walkingup = this.showOrderDetails = this.buyTickets = this.buyPasses = this.buySeriesPasses = this.applyingpass = this.addingpass = this.moving = this.movingshow = false;
      this.selectedOrder = null;
      this.selectedEventId = null;
      this.reauthMessage = "";
      if (this.userInvite) store.dispatch("clearInvite");
      this.$analytics.logEvent("modal_dismissed");
    },
    createduser() {
      this.signup = false;
      //if (newuser.type == "artist") this.createArtist = true;
      //else this.createVenue = true;
      this.$router.push({ name: "profile" });
      this.$analytics.logEvent("account_created");
    },
    loggedin() {
      this.login = false;
      this.reauthMessage = "";
      this.$analytics.logEvent("logged_in");
    },
    loggedout() {
      store.dispatch("logOutUser");
      this.logout = false;
      this.$router.replace("/");
      firebase.auth().signOut();
      this.$analytics.logEvent("logged_out");
    },
    profileCreated() {
      this.createVenue = this.createArtist = false;
    },
    signmeup(source) {
      this.signup = true;
      this.$analytics.logEvent("signup_opened", { source: source });
    },
    addcomp() {
      this.addingcomp = true;
    },
    walkup() {
      this.walkingup = true;
    },
    orderdetails(order, eventId) {
      this.selectedOrder = order;
      this.selectedEventId = eventId;
      this.showOrderDetails = true;
    },
    pass() {
      this.applyingpass = true;
    },
    newpass() {
      this.addingpass = true;
    },
    move() {
      console.log("move it now");
      this.moving = true;
    },
    moveshow() {
      console.log("moveshow it now");
      this.movingshow = true;
    },
    sellTickets() {
      this.buyTickets = true;
    },
    sellPasses() {
      this.buyPasses = true;
    },
    sellSeriesPasses() {
      this.buySeriesPasses = true;
    },
    createEvent() {
      store.dispatch("newEvent");
      this.$router.push({ name: "createEvent" });
    },
    createFestival() {
      store.dispatch("newFestivalSeason");
      this.$router.push({ name: "createFestival" });
    },
    onOnboardingComplete() {
      store.dispatch("hideOnboarding");
      // Route based on whether user has created events
      if (this.user && this.user.eventCreated) {
        this.$router.push({ name: "events" });
      } else {
        // Initialize new event before navigating to create event page
        store.dispatch("newEvent");
        this.$router.push({ name: "createEvent" });
      }
    },
    async cleanupServiceWorkers() {
      console.log("Cleaning up service workers and caches...");

      // Clear all caches
      if ("caches" in window) {
        try {
          const cacheNames = await caches.keys();
          console.log("Deleting", cacheNames.length, "caches");
          await Promise.all(cacheNames.map(name => caches.delete(name)));
        } catch (error) {
          console.error("Error clearing caches:", error);
        }
      }

      // Unregister all service workers
      if ("serviceWorker" in navigator) {
        try {
          const registrations = await navigator.serviceWorker.getRegistrations();
          console.log("Unregistering", registrations.length, "service workers");
          await Promise.all(registrations.map(reg => reg.unregister()));
        } catch (error) {
          console.error("Error unregistering service workers:", error);
        }
      }
    }
  }
};
</script>
